import styled from 'styled-components';

export const SelectContainer = styled.div`
  min-height: 350px;
  width: 272px;
  padding: var(--spacing-05);
`;
